import { ACCESS_TOKEN, REFRESH_TOKEN, PROVIDER_ID } from '../store/domains/auth/constants';

export const saveAllTokens = (data) => {
  localStorage.setItem(ACCESS_TOKEN, data.accessToken);
  localStorage.setItem(REFRESH_TOKEN, data.refreshToken);
};
export const removeAllTokens = () => {
  localStorage.clear(ACCESS_TOKEN);
  localStorage.clear(REFRESH_TOKEN);
  localStorage.clear(PROVIDER_ID);
};
